import { Box, FormControl, FormControlLabel, Switch } from '@mui/material'
import TruncatedText from './TruncatedText'
import { ReactElement } from 'react'

interface SwitchInputProps {
    id: string
    label: string
    value: boolean
    onChange: any
    required?: boolean
    disabled?: boolean
}

const SwitchInput = (props: SwitchInputProps): ReactElement => {
    const { id, label, value, onChange, required, disabled } = props

    return (
        <Box sx={{ width: '100%', marginTop: '20px' }}>
            <FormControl fullWidth disabled={!!disabled}>
                {/* <Typography
                    sx={{ opacity: '0.7', fontSize: '14px', height: '16px' }}
                >
                    {label}
                    {required ? '*' : ''}
                </Typography> */}
                <FormControlLabel
                    control={
                        <Switch
                            id={id}
                            checked={value}
                            onChange={(e: any) =>
                                onChange(id, e.target.checked)
                            }
                            name={label}
                            sx={{
                                marginRight: '5px',
                            }}
                        />
                    }
                    label={
                        <Box width="100%">
                            <TruncatedText
                                text={label + (required ? '*' : '')}
                            />
                        </Box>
                    }
                    sx={{
                        width: '100%',
                        display: 'flex',
                        '& .MuiFormControlLabel-label': {
                            flex: 1,
                            maxWidth: 'calc(100% - 52px)',
                        },
                    }}
                />
            </FormControl>
        </Box>
    )
}

export default SwitchInput
